<template>
  <div class="page">
    <div class="app-container">
      <!-- <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch> -->
      <BaseTable
        ref="baseTable"
        url="/admin/set/invoice"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
        <template #handle="{ row }">
          <el-button type="text" size="mini" v-if="row.status == 2" @click="handleRow(row, 'completed')">审核</el-button>
          <!-- <el-button type="text" @click="handleRow(row, 'detail')">详情</el-button> -->
          <!-- <el-button type="text" v-if="row.status != 4" @click="handleRow(row, 'edit')">编辑</el-button> -->
        </template>
      </BaseTable>
      <!-- 补偿审核 -->
      <el-dialog  title="补偿审核" :visible.sync="CodeReviewBefor" width="40%" @close="CodeReviewBefor = false">
        <el-form inline ref="completedata" label-width="150px" class="demo-ruleForm">
            <el-form-item class="from-item--30" label="类型" prop="claims_type">
              <el-select v-model="claims_type" filterable>
                <el-option label="平台承担" value="1"></el-option>
                <el-option label="进行分摊" value="2"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item class="from-item--30" label="备注" prop="beizhu" >
              <el-input v-model="beizhu" placeholder="备注" />
            </el-form-item>
            <br>
            <div style="margin-left:50px;">
              <el-button size="mini" @click="CodeReviewBefor = false">取消</el-button>
              <el-button size="mini" @click="setReview">确定</el-button>
            </div>
          </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";
import { status } from "nprogress";

export default {
  name: "Log",
  comments: {},
  data() {
    return {
      tableData: [],
      searchData: {},
      CodeReviewBefor:false,
      id:0,
    };
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {
    
  },
  methods: {
    async handleChangeFile(file, item) {
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        if(item == 1){
          this.repairPhoto.push({
            imageType: 1,
            url: res.data.path,
          });
        } else if (item == 4) {
          this.acceptancePhoto.push({
            imageType: 4,
            url: res.data.path,
          });
        } else {
          this.completedPhoto.push({
            imageType: 2,
            url: res.data.path,
          });
        }
        
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    handleRow(row, k) {
      switch (k) {
        case "detail":
          this.handleDetail(row);
          break;
        case "completed":
          this.handleCompleted(row);
          break;
        default:
          break;
        }
    },
    handleCompleted({ id }){
      this.id = id
      this.CodeReviewBefor = true;
    },
    setReview(){
      const res = this.$api.post("/admin/accident/setDerepair", {
        id: this.id,
        claims_type: this.claims_type,
        beizhu: this.beizhu,
        status: 4
      });
      this.CodeReviewBefor = false;
      this.claims_type = 0;
      this.beizhu = '';
      let that = this;
      setTimeout(() => {
        that.handleSearch();
      }, 1000);
      
    },
    // 点击详情
    handleDetail({ id }) {
      this.$router.push({
        path: "/accident/detail",
        query: {
          id,
        },
      });
    },
    // 点击编辑
    handleEdit({ id }) {
      this.$router.push({
        path: "/accident/apply",
        query: {
          id,
        },
      });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>
